import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { IconComponent } from '../icon/icon.component';

@Component({
  standalone: true,
  selector: 'capra-banner',
  imports: [CommonModule, IconComponent],
  templateUrl: './banner.component.html',
  styleUrls: ['./banner.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BannerComponent {
  @Input() header = '';
  @Input() text = '';
  @Input() icon = '';
  @Input() warningMessage = '';
  @Input() tipMessage = '';
}
